import { ApplicationLayout } from "../../modules/layout/components/application-layout";
import { Layout } from "../../modules/layout/components/layout";
import { usePrograms2026 } from "../../modules/program-tree/hooks/use-programs-2026";
import ProgramTreePage from "./program-tree-page";

import type { FC, ReactElement } from "react";

/** The program tree page when cha_4265_programs_2026 is on, else the original page. */
export const ProgramsPageGate: FC<{ original: ReactElement }> = ({ original }) => {
  const { enabled, loaded } = usePrograms2026();

  if (!loaded) return null;
  return enabled ? <ProgramTreePage /> : original;
};

/**
 * The layout of the programs pages. With cha_4265_programs_2026 on, the full page layout: the page
 * has its own header bar, and the sidebar is collapsed until the header bar opens it. Else the
 * original layout, with the sidebar always open on a wide screen.
 */
export const ProgramsLayoutGate: FC = () => {
  const { enabled, loaded } = usePrograms2026();

  if (!loaded) return null;
  return enabled ? <ApplicationLayout layout="content" /> : <Layout />;
};
